var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "customer-service-confirmation"
  }, [_c('h1', {
    staticClass: "main-title"
  }, [_vm._v(_vm._s(_vm.displayData.title))]), _c('div', {
    staticClass: "content-body"
  }, _vm._l(_vm.contentLines, function (line, index) {
    return _c('p', {
      key: index,
      staticClass: "content-line"
    }, [_vm._v(" " + _vm._s(line) + " ")]);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }